module.exports = __webpack_public_path__ + "static/media/report3.05506c4f.xlsx";